import axiosInstance from 'api/axiosInstance/axiosInstance'
import type { CarBrand } from '../types'

export const fetchCarBrands = async (): Promise<Array<CarBrand>> => {
  const response = await axiosInstance.get('/carBrandsRead')
  const payload = response?.data?.payload
  return Array.isArray(payload) ? payload : []
}
